import {Application} from "@hotwired/stimulus"
import {definitionsFromContext} from "@hotwired/stimulus-webpack-helpers"

export const setupStimulus = () => {
	const application = Application.start()
	const context = require.context("../controllers", true, /.*controller\.js$/)
	application.load(definitionsFromContext(context))
}
